export default {
  setTokenAction (context, payload) {
    context.commit('setToken', payload)
  },
  setAccountAction (context, payload) {
    context.commit('setAccount', payload)
  }
}
